export class ngCellTouchEvent
{
	#owner;
	#timer;
	#touchStartX;
	#touchStartX2;
	#touchStartY;
	#touchStartY2;
	#touchStartRow;
	#touchStartTime;
	
	#bodyTop = 0;

	constructor(owner) {

		this.#owner = owner;
		this.resetEvent();
	};
	
	#getElement = (y) => {
			
		var element;
		
		$(`.ng-container-body tbody.bindable tr`, this.#owner.body).each((i,tr) => {

			var offset = $(tr).offset();
			
			if (y >= offset.top && y <= offset.top + $(tr).height()) {
				element = tr;
				return false;
			}
		});
		
		
		return element;
	}

	#createTopTR = (gap) => {
		
		var rowCount = this.#getEmptyTopRowCount(gap);

		if (rowCount > 0) {
			
			if (rowCount > this.#owner.dataManager.viewRecords.rawIndex) {
				rowCount = this.#owner.dataManager.viewRecords.rawIndex;
			}
			
			const leftTmpl	= this.#owner.template.clone();
			const rightTmpl	= leftTmpl.clone();//this.#owner.template.clone();
			const bodyTmpl	= leftTmpl.clone();//this.#owner.template.clone();
			
			leftTmpl	.find("th,td").not("[fixed=left]").remove();
			rightTmpl	.find("th,td").not("[fixed=right]").remove();
			bodyTmpl	.find("th[fixed=left],td[fixed=left],th[fixed=right],td[fixed=right]").remove();
			
			const leftNoData	= $("tbody.bindable tr:first-child", this.#owner.body.querySelector(".ng-container-left"));
			const rightNoData	= $("tbody.bindable tr:first-child", this.#owner.body.querySelector(".ng-container-right"));
			const bodyNoData	= $("tbody.bindable tr:first-child", this.#owner.body.querySelector(".ng-container-body"));
			
			const row = this.#owner.view.getVisibleFirstRow();
			
			for (var i = 0; i < rowCount; i++) {
				
				leftTmpl	.each((j,tr) => { tr.dataset.row = row - rowCount + i;		leftNoData	.before(tr.outerHTML); });
				rightTmpl	.each((j,tr) => { tr.dataset.row = row - rowCount + i;		rightNoData	.before(tr.outerHTML); });
				bodyTmpl	.each((j,tr) => { tr.dataset.row = row - rowCount + i;		bodyNoData	.before(tr.outerHTML); });
			}
			
			
		}
		
		return rowCount;
	};
	
	#createBottomTR = (gap) => {
		
		var rowCount = this.#getEmptyBottomRowCount(gap);
		if (rowCount > 0) {

			if (this.#owner.view.getVisibleLastRow() + rowCount >= this.#owner.data.count()) {

				rowCount = this.#owner.data.count() - this.#owner.view.getVisibleLastRow() - 1;
			}
			
			//const lastRow = this.#owner.view.getVisibleLastRow();

			const leftTmpl	= this.#owner.template.clone();
			const rightTmpl	= leftTmpl.clone();//this.#owner.template.clone();
			const bodyTmpl	= leftTmpl.clone();//this.#owner.template.clone();
			
			leftTmpl	.find("th,td").not("[fixed=left]").remove();
			rightTmpl	.find("th,td").not("[fixed=right]").remove();
			bodyTmpl	.find("th[fixed=left],td[fixed=left],th[fixed=right],td[fixed=right]").remove();
			
			const leftNoData	= $("tr.nodata", this.#owner.body.querySelector(".ng-container-left"));
			const rightNoData	= $("tr.nodata", this.#owner.body.querySelector(".ng-container-right"));
			const bodyNoData	= $("tr.nodata", this.#owner.body.querySelector(".ng-container-body"));
			
			const row = this.#owner.view.getVisibleLastRow() + 1;
			
			for (var i = 0; i < rowCount; i++) {
				
				leftTmpl	.each((j,tr) => { tr.dataset.row = row + i;		leftNoData	.before(tr.outerHTML); });
				rightTmpl	.each((j,tr) => { tr.dataset.row = row + i;		rightNoData	.before(tr.outerHTML); });
				bodyTmpl	.each((j,tr) => { tr.dataset.row = row + i;		bodyNoData	.before(tr.outerHTML); });
			}
		}
		
		return rowCount;
	};
	
	
	
	#getEmptyTopRowCount = (gap) => {
		
		const firstRow = this.#owner.view.getVisibleFirstRow();
		const totalSpace = this.#bodyTop + gap;

		if (firstRow <= 0) return 0;
		
		var rowCount = 0;
		var h = 0;

		while (h < totalSpace) {
			h += this.#owner.view.getRowHeight(firstRow - ++rowCount);
		}
	
		return rowCount;
	};
	
	#getEmptyBottomRowCount = (gap) => {
		
		const totalSpace	= this.#owner.view.getTotalSpace() - this.#owner.view.getTranslateY() + gap;
		const firstRow		= this.#owner.view.getVisibleFirstRow();
		const lastRow		= this.#owner.view.getVisibleLastRow();

		var h = 0;
		var rowCount = 0;
		while (h < totalSpace) {
			h += this.#owner.view.getRowHeight(firstRow + rowCount++);
		}
	
		return rowCount + 1 - (lastRow - firstRow + 1);
	};

	#removeTopTR = () => {

		const firstRow = this.#owner.view.getVisibleFirstRow();
		const lastRow = this.#owner.view.getVisibleLastRow();
		
		var topRow = firstRow;
		var h = 0;
		for (var i = firstRow; i < lastRow; i++) {

			h += this.#owner.view.getRowHeight(i);
			
			if (h > this.#bodyTop * -1) {
				
				h -= this.#owner.view.getRowHeight(i);
				topRow = i;
				break;
			}
		}
			
		/** 상단 보이지않는 TR 제거 */
		if (topRow > firstRow) {

			for (var i = firstRow; i < topRow; i++) {
				
				this.#owner.body.querySelectorAll(`tbody.bindable tr[data-row="${i}"]`).forEach(tr => {
					$(tr).remove();
				});
			}
			
			this.#bodyTop = (h * -1 - this.#bodyTop) * -1;
			
			this.#owner.body.querySelectorAll("tbody.bindable").forEach(tbody => {
				//tbody.style.top = top + "px";
				tbody.style.transform = `translateY(${this.#bodyTop}px)`;
			});
		}
		
		return topRow - firstRow;
	};
	
	#removeBottomTR = () => {

		/** 하단 보이지않는 TR 제거 */
		const totalSpace	= this.#owner.view.getTotalSpace() - this.#owner.view.getTranslateY();
		const firstRow		= this.#owner.view.getVisibleFirstRow();
		const lastRow		= this.#owner.view.getVisibleLastRow();
		
		var removeStartRow = this.#owner.data.count();
		var h = 0;
		for (var i = firstRow; i <= lastRow; i++) {
			h += this.#owner.view.getRowHeight(i);
			
			if (h > totalSpace) {
				removeStartRow = i + 1;
				break;
			}
		}
		
		for (i = removeStartRow; i <= lastRow; i++) {
			this.#owner.body.querySelectorAll(`tbody.bindable tr[data-row="${i}"]`).forEach(tr => {
				
				$(tr).remove();
			});
		}
		
		return lastRow - removeStartRow;
	};

	scrollTop = () => {
		this.#bodyTop = 0;
		this.#owner.body.querySelectorAll("tbody.bindable").forEach(tbody => {
			tbody.style.transform = `translateY(${this.#bodyTop}px)`;
		});
	};
	
	#onTouchStart = (e) => {
			
		clearInterval(this.#timer);

		//e.preventDefault();

		this.#touchStartX	= e.touches[0].pageX;
		this.#touchStartX2	= e.touches[0].pageX - $(".ng-container-body table", this.#owner.body).position().left;
		this.#touchStartY	= e.touches[0].pageY;
		this.#touchStartY2	= e.touches[0].pageY;
		this.#touchStartTime= new Date();

		const tr = this.#getElement(e.touches[0].pageY);
		if (tr) this.#touchStartRow = parseInt(tr.dataset.row);
	};
	
	
	#onTouchMove = (e) => {
		
		if (e.touches.length > 1 || e.changedTouches.length > 1) return;
		
		e.preventDefault();

		/**
		if (!this.#scrollDirect) {
			if (Math.abs(e.changedTouches[0].pageY - this.#touchStartY) > 10) {
				this.#scrollDirect = e.changedTouches[0].pageY > this.#touchStartY ? "down" : "up";
			}
			else if (Math.abs(e.changedTouches[0].pageX - this.#touchStartX) > 10) {
				this.#scrollDirect = e.changedTouches[0].pageX - this.#touchStartX ? "right" : "left";
			}
		}
		*/
		
		if (Math.abs(e.changedTouches[0].pageY - this.#touchStartY2) > 0) {

			if (e.changedTouches[0].pageY > this.#touchStartY2) {

				if (this.#bodyTop + e.changedTouches[0].pageY - this.#touchStartY2 > 0 && this.#owner.view.getVisibleFirstRow() != 0) {
					const rowCount = this.#createTopTR(e.changedTouches[0].pageY - this.#touchStartY2);
					if (rowCount > 0) {
						var row = this.#owner.view.getVisibleFirstRow();
						for (var i = row; i < row + rowCount; i++) {
							this.#bodyTop -= this.#owner.view.getRowHeight(i);
						}

						this.#owner.dataManager.viewRecords.rawIndex -= rowCount;
						this.#owner.view.redrawV3();
					}
				}
			}
			else if (e.changedTouches[0].pageY < this.#touchStartY2) {
				if (this.#createBottomTR(this.#touchStartY2 - e.changedTouches[0].pageY) > 0) {
					//removeHeight = this.#removeTopTR();
					this.#owner.view.redrawV3();
				}
			}
			
			this.#bodyTop += e.changedTouches[0].pageY - this.#touchStartY2;
			
			/**
			 * Safari에서 top 적용시 이동안됨, transform로 대체
			 */
			this.#owner.body.querySelectorAll("tbody.bindable").forEach(tbody => {
				//tbody.style.top = top + "px";
				tbody.style.transform = `translateY(${this.#bodyTop}px)`;
			});
		
			this.#touchStartY2 = e.changedTouches[0].pageY;
			
		}
		else if (Math.abs(e.changedTouches[0].pageX - this.#touchStartX) > 20) {
			var l = e.changedTouches[0].pageX - this.#touchStartX2;
			if (l > 0) l = 0;
			
			$(".ng-container-body table", this.#owner.body).css({left : l});
			this.#owner.body.querySelector("ng-hscrollbar").adjustThumb2();
		}
	};
	
	#onTouchEnd = (e) => {
		
		
		//if ((this.#owner.view.getVisibleFirstRow() == 0 && this.#bodyTop > 0) || this.#owner.isLastPage) {
		if (this.#owner.view.getVisibleFirstRow() == 0 && this.#bodyTop > 0) {
			this.scrollTop();
		}
		
		var removeRowCount = this.#removeTopTR();
		this.#owner.dataManager.viewRecords.rawIndex += removeRowCount;
		

		this.#removeBottomTR();
		
		
		const totalSpace = this.#owner.view.getTotalSpace() - this.#owner.view.getTranslateY();
		
		var h = 0;
		for (var i = this.#owner.view.getVisibleFirstRow(); i <= this.#owner.view.getVisibleLastRow(); i++) {
			h += this.#owner.view.getRowHeight(i);
		}
		
		$(".ng-container tbody.bindable tr.nodata", this.#owner.body).height(totalSpace - h);
		
		
		this.#owner.view.fitPage();
		

		// mobile wheel
		const tr = this.#getElement(e.changedTouches[0].pageY);
		if (!tr || this.#touchStartRow == parseInt(tr.dataset.row)) return;

		const maxDelta = 500;
		const delta = parseInt(new Date() - this.#touchStartTime);
		
		if (delta > maxDelta) return;
		

		const deltaRow = parseInt((maxDelta - delta) / 1 * ((this.#owner.data.count() - this.#owner.dataManager.viewRecords.rawIndex) / 1) / (maxDelta * 1));
		const toRow = this.#owner.dataManager.viewRecords.rawIndex + deltaRow * (e.changedTouches[0].pageY > this.#touchStartY ? -1 : 1);

		clearInterval(this.#timer);
		if (toRow > this.#owner.dataManager.viewRecords.rawIndex) {
			this.#timer = setInterval(() => {
				this.#owner.scrollBy(1);
				//if (this.#owner.dataManager.viewRecords.rawIndex >= toRow) {
				if (this.#owner.view.getVisibleLastRow() >= toRow) {
					clearInterval(this.#timer);
				}
			}, 10);
		}
		else {
			this.#timer = setInterval(() => {
				this.#owner.scrollBy(-1);
				if (this.#owner.dataManager.viewRecords.rawIndex <= toRow) {
					clearInterval(this.#timer);
				}
			}, 10);
		}
	};
	
	#onTouchCancel = (e) => {
		
	};

	resetEvent = () => {
		$("tbody.bindable", 			this.#owner.body).off("touchstart",				this.#onTouchStart);
		$("tbody.bindable", 			this.#owner.body).off("touchend",				this.#onTouchEnd);
		$("tbody.bindable",			 	this.#owner.body).off("touchmove",				this.#onTouchMove);
		$("tbody.bindable",				this.#owner.body).off("touchcancel",			this.#onTouchCancel);

		$("tbody.bindable", 			this.#owner.body).on("touchstart",				this.#onTouchStart);
		$("tbody.bindable", 			this.#owner.body).on("touchend",				this.#onTouchEnd);
		$("tbody.bindable", 			this.#owner.body).on("touchmove",				this.#onTouchMove);
		$("tbody.bindable", 			this.#owner.body).on("touchcancel",				this.#onTouchCancel);
	}
}
